<app-master-crud [TableName]="'cb_LogSystem'" [Atributos]="Atributos"></app-master-crud>